// Google Analytics 4 Event Tracking Utility

/**
 * Track custom events in Google Analytics
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
    console.log('GA4 Event:', eventName, eventParams);
  }
};

/**
 * Track page views manually
 * @param {string} pagePath - Path of the page
 * @param {string} pageTitle - Title of the page
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA4_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle
    });
    console.log('GA4 Page View:', pagePath, pageTitle);
  }
};

// Pre-defined event tracking functions for common actions

export const trackRestaurantAdded = (restaurantName) => {
  trackEvent('restaurant_added', {
    restaurant_name: restaurantName,
    category: 'Restaurant Management'
  });
};

export const trackVisitLogged = (restaurantName) => {
  trackEvent('visit_logged', {
    restaurant_name: restaurantName,
    category: 'Visit Management'
  });
};

export const trackPhotoUploaded = (restaurantName, photoCount) => {
  trackEvent('photo_uploaded', {
    restaurant_name: restaurantName,
    photo_count: photoCount,
    category: 'Content Creation'
  });
};

export const trackPhotoRotated = (restaurantName) => {
  trackEvent('photo_rotated', {
    restaurant_name: restaurantName,
    category: 'Photo Management'
  });
};

export const trackEmailSent = (recipientType, recipientCount) => {
  trackEvent('email_sent', {
    recipient_type: recipientType,
    recipient_count: recipientCount,
    category: 'Admin Communication'
  });
};

export const trackLogin = (userEmail, isAdmin) => {
  trackEvent('login', {
    user_type: isAdmin ? 'admin' : 'user',
    category: 'Authentication'
  });
};

export const trackLogout = () => {
  trackEvent('logout', {
    category: 'Authentication'
  });
};

export const trackDashboardView = (dashboardType) => {
  trackEvent('dashboard_view', {
    dashboard_type: dashboardType,
    category: 'Navigation'
  });
};

export const trackRestaurantSearch = (searchTerm) => {
  trackEvent('restaurant_search', {
    search_term: searchTerm,
    category: 'Search'
  });
};

export const trackMapInteraction = (interactionType) => {
  trackEvent('map_interaction', {
    interaction_type: interactionType,
    category: 'Map'
  });
};

export const trackFilterApplied = (filterType, filterValue) => {
  trackEvent('filter_applied', {
    filter_type: filterType,
    filter_value: filterValue,
    category: 'Filtering'
  });
};

export const trackAdminPanelAccess = () => {
  trackEvent('admin_panel_access', {
    category: 'Admin'
  });
};

export const trackAnalyticsExport = (exportType) => {
  trackEvent('analytics_export', {
    export_type: exportType,
    category: 'Admin Analytics'
  });
};
